import { render } from "./dermatology_notes.vue?vue&type=template&id=15e45628&scoped=true"
import script from "./dermatology_notes.vue?vue&type=script&lang=js"
export * from "./dermatology_notes.vue?vue&type=script&lang=js"

import "./dermatology_notes.vue?vue&type=style&index=0&id=15e45628&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e45628"]])

export default __exports__